import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarChart = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.8522 11.8447L11.8522 11.728C11.8522 11.329 11.5528 11.0073 11.1986 11.0073L2.01624 11.0073L2.01624 9.64721L8.09573 9.64721C8.45306 9.64721 8.74953 9.32929 8.74953 8.92647L8.74953 8.80973C8.74953 8.4069 8.45306 8.08899 8.09573 8.08899L2.01624 8.08899L2.01624 2.67065C2.01624 1.77645 0.799949 1.77645 0.799949 2.67065L0.799949 21.3201C0.799949 21.6953 1.07232 22 1.40808 22L1.69567 22L20.3919 22C20.7275 22 21 21.6955 21 21.3201C21 20.9448 20.7276 20.6402 20.3919 20.6402L2.01598 20.6402L2.01598 18.4013L16.824 18.4013C17.1814 18.4013 17.4778 18.0834 17.4778 17.6806L17.4778 17.5639C17.4778 17.161 17.1814 16.8431 16.824 16.8431L2.01598 16.8431L2.01598 15.4831L14.632 15.4831C14.9893 15.4831 15.2858 15.1652 15.2858 14.7623L15.2858 14.6456C15.2858 14.2428 14.9893 13.9249 14.632 13.9249L2.01598 13.9249L2.01598 12.565L11.207 12.565C11.5577 12.5601 11.8522 12.2397 11.8522 11.8447Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgBarChart;
